import {createAsyncThunk} from "@reduxjs/toolkit";
import request from "../../../../../../../service";
import {IErrorResponse, IRootState} from "../../../../../../../types";
import {
    INormTypesCreate, INormTypesPayload
} from "../types";

import {
    deletedRestoreNormTypes,
    deleteNormTypes,
    setNormTypes, setNormTypesRestoreData, updateNormTypes
} from "./normTypesSlice";


const CreateNormTypes = createAsyncThunk(
    "create/norm/types",
    async (payload: INormTypesCreate, { rejectWithValue }) => {
        try {
            const response = await request.post("/norm-types", payload);

            return response.data;
        }  catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);

const GetNormTypes= createAsyncThunk(
    "get/norm/types",
    async (_, { dispatch, rejectWithValue,getState }) => {
        try {
            const response = await request.get("/norm-types");
            const lang = getState()  as IRootState
            const defaultLanguage = lang.languages.defaultLanguage
            dispatch(setNormTypes({ data: response.data,defaultLanguage }));
            return response.data;
        }  catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");

        }
    }
);

const EditNormTypes= createAsyncThunk(
    "edit/norm/types",
    async ( data : INormTypesPayload, { dispatch, rejectWithValue }) => {
        try {
            const response = await request.put(`/norm-types/${data.id}`, data);
            dispatch(updateNormTypes(response.data));
            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);


const DeleteNormTypes= createAsyncThunk(
    "delete/norm/types",
    async (id : number, { dispatch,rejectWithValue }) => {
        try {
            const response = await request.delete(`/norm-types/${id}`);

            dispatch(deleteNormTypes(id));
            return response.data;
        }  catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");

        }
    }
);

const GetDeleteNormTypes= createAsyncThunk(
    "get/delete/norm/types",
    async (_,{ dispatch,rejectWithValue }) => {
        try {
            const response = await request.get(`/norm-types/deleted-items`);

            dispatch(setNormTypesRestoreData(response.data));

            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");

        }
    }
);

const RestoreDeleteNormTypes = createAsyncThunk(
    "restore/delete/norm/types",
    async (id:number,{ dispatch,rejectWithValue }) => {
        try {
            const response = await request.post(`/norm-types/restore/${id}`);

            dispatch(deletedRestoreNormTypes(id));

            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");

        }
    }
);


export{
    CreateNormTypes,
    GetNormTypes,
    EditNormTypes,
    DeleteNormTypes,
    GetDeleteNormTypes,
    RestoreDeleteNormTypes
}